import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, EffectFade } from 'swiper/modules'
import { useHydrated } from '@/hooks/useHydrated'
import { useIsDesktop } from '@/hooks/useIsDesktop'
import Image from 'next/image'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

const slides = [
  {
    id: 1,
    number: '01',
    title: '0% Anzahlung',
    description: 'Sie zahlen erst bei Leistung. So haben Sie kaum Risiko.',
  },
  {
    id: 2,
    number: '02',
    title: 'Günstiger Preis',
    description:
      'Welche Lösung auch immer die Beste für Sie ist: Unsere Angebote zählen zu den Günstigsten, die Sie kriegen können.',
  },
  {
    id: 3,
    number: '03',
    title: 'Qualität',
    description:
      'Trotz günstiger Preise bieten wir hochwertige Markenprodukte und setzen auf deutsches Handwerk.',
  },
]

export default function FeatureSwiper() {
  const isHydrated = useHydrated()
  const isDesktop = useIsDesktop(768)

  if (!isHydrated) return null

  return (
    <div className="relative mx-auto max-w-7xl pb-4 sm:block lg:hidden">
      <Swiper
        modules={[Autoplay, Pagination]}
        className="feature-swiper"
        slidesPerView={1}
        spaceBetween={30}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {/* Render slides dynamically */}
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="relative flex h-[156px] min-h-[156px] w-full flex-col items-center justify-center rounded-lg bg-black/40 px-4 py-2 text-center shadow-lg backdrop-blur-sm transition-all">
              <div className="mb-2 text-lg text-[#ff4500]">{slide.number}</div>
              <h3 className="mb-2 text-xl font-bold text-white">{slide.title}</h3>
              <p className="text-sm text-gray-100">{slide.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
